import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LoadingService, LoadingState } from '../../services/loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit, OnDestroy {
  @Input() overlay: boolean = true;
  @Input() backdrop: boolean = true;
  @Input() transparent: boolean = false;

  loadingState: LoadingState = {
    isLoading: false,
    message: '',
    type: 'spinner'
  };

  private subscription: Subscription = new Subscription();

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.loadingService.loading$.subscribe(state => {
        this.loadingState = state;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get isVisible(): boolean {
    return this.loadingState.isLoading;
  }

  get loadingMessage(): string {
    return this.loadingState.message || 'Loading...';
  }

  get loadingType(): string {
    return this.loadingState.type || 'spinner';
  }
}